import React from 'react';
import ReactMarkdown from 'react-markdown';

interface MarkdownRendererProps {
  content: string;
  className?: string;
}

const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({ content, className }) => {
  return (
    <div className={className}>
      <ReactMarkdown
        components={{
          // Custom styling for different markdown elements
          h1: ({ children }) => (
            <h1 style={{ 
              fontSize: '1.5em', 
              fontWeight: 'bold', 
              marginBottom: '12px',
              color: '#2c3e50',
              borderBottom: '2px solid #3498db',
              paddingBottom: '4px'
            }}>
              {children}
            </h1>
          ),
          h2: ({ children }) => (
            <h2 style={{ 
              fontSize: '1.3em', 
              fontWeight: 'bold', 
              marginBottom: '10px',
              marginTop: '16px',
              color: '#2c3e50'
            }}>
              {children}
            </h2>
          ),
          h3: ({ children }) => (
            <h3 style={{ 
              fontSize: '1.1em', 
              fontWeight: 'bold', 
              marginBottom: '8px',
              marginTop: '12px',
              color: '#34495e'
            }}>
              {children}
            </h3>
          ),
          p: ({ children }) => (
            <p style={{ 
              marginBottom: '12px',
              lineHeight: '1.6',
              color: '#2c3e50'
            }}>
              {children}
            </p>
          ),
          ul: ({ children }) => (
            <ul style={{ 
              marginBottom: '12px',
              paddingLeft: '20px',
              color: '#2c3e50'
            }}>
              {children}
            </ul>
          ),
          ol: ({ children }) => (
            <ol style={{ 
              marginBottom: '12px',
              paddingLeft: '20px',
              color: '#2c3e50'
            }}>
              {children}
            </ol>
          ),
          li: ({ children }) => (
            <li style={{ 
              marginBottom: '4px',
              lineHeight: '1.5'
            }}>
              {children}
            </li>
          ),
          strong: ({ children }) => (
            <strong style={{ 
              fontWeight: 'bold',
              color: '#2c3e50'
            }}>
              {children}
            </strong>
          ),
          em: ({ children }) => (
            <em style={{ 
              fontStyle: 'italic',
              color: '#34495e'
            }}>
              {children}
            </em>
          ),
          code: ({ children }) => (
            <code style={{ 
              background: '#f8f9fa',
              padding: '2px 6px',
              borderRadius: '4px',
              fontSize: '0.9em',
              fontFamily: 'Monaco, Consolas, "Courier New", monospace',
              color: '#e74c3c',
              border: '1px solid #e1e8ed'
            }}>
              {children}
            </code>
          ),
          pre: ({ children }) => (
            <pre style={{ 
              background: '#f8f9fa',
              padding: '12px',
              borderRadius: '6px',
              overflow: 'auto',
              marginBottom: '12px',
              border: '1px solid #e1e8ed',
              fontSize: '0.9em',
              fontFamily: 'Monaco, Consolas, "Courier New", monospace'
            }}>
              {children}
            </pre>
          ),
          blockquote: ({ children }) => (
            <blockquote style={{ 
              borderLeft: '4px solid #3498db',
              paddingLeft: '16px',
              marginLeft: '0',
              marginBottom: '12px',
              fontStyle: 'italic',
              color: '#7f8c8d',
              background: '#f8f9fa',
              padding: '12px 16px',
              borderRadius: '0 6px 6px 0'
            }}>
              {children}
            </blockquote>
          ),
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownRenderer;